module.exports = __webpack_public_path__ + "img/cart-list-item-bg.050cddc8.png";